<script setup lang="ts">
import { computed } from "vue";

import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface LoadingSpinnerProps {
  size: iconSize;
}

const props = withDefaults(defineProps<LoadingSpinnerProps>(), { size: "md" });

const sizeClass = computed((): string => `icon-${props.size}`);
</script>

<template>
  <div class="spinner">
    <div v-for="index in 3" :key="index" class="dot" :class="sizeClass" />
  </div>
</template>

<style scoped lang="scss">
@keyframes loadingFade {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.spinner {
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;

  .dot {
    @include colors.bg(secondary, high);

    border-radius: 50%;
    animation: loadingFade 0.6s infinite;
  }

  .dot:nth-child(2) {
    animation-delay: 0.1s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.2s;
  }
}
</style>
